export const routes = {
    DEFAULT: '/',
    STATUS: '/status',
    ACCOUNT: '/account',
    ACTIVITY: '/activity',
    BOOKINGS: '/bookings',
} as const;
